export default import.meta.ROLLUP_FILE_URL_2ZEzIIM_atdpHcr$6kvj$Q;